import {NgModule} from '@angular/core';
import {RolesDirective} from './directives/roles.directive';
import {PemrissionsDirective} from './directives/pemrissions.directive';
import {JwtHelperService} from '@auth0/angular-jwt';
import {CookieService} from 'ngx-cookie-service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenInterceptorService} from './services/token-interceptor.service';

@NgModule({
  declarations: [
    RolesDirective,
    PemrissionsDirective,
  ],
  imports: [],
  providers: [
    JwtHelperService,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
  ],
  exports: [
    RolesDirective,
    PemrissionsDirective,
  ]
})
export class AuthenticationModule {
}
